import PropTypes from 'prop-types';
import React from 'react';

// TODO: make screenLoader component with all necessary styles
const ScreenLoader = ({ error }) => (
  <div className="ui__loader d-flex justify-content-center align-items-center">
    {!error ? 'Loading...' : error.toString()}
  </div>
);

ScreenLoader.propTypes = {
  error: PropTypes.string || null || undefined,
};

ScreenLoader.defaultProps = {
  error: null,
};

export default ScreenLoader;
